/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  // Caixas, times, fila e última atividade de cada agente — só a tela de
  // Agentes usa, pra lista de dropdown nenhuma pagar por isso.
  overview() {
    return axios.get(`${this.url}/overview`);
  }
}

export default new Agents();
